import epics from './sportsPage.epics';
import reducers from './sportsPage.reducers';

export { epics, reducers };
